import $ from "jquery";

window.appThemeServiceMethods = {
	applyTheme : (themeMode) => {
		$("html").attr("data-bs-theme",themeMode)
	}
}
